import { Injectable } from '@angular/core';
import { StorageService } from '@app/services/storage';
import { Sucursal } from '@config-empresa/sucursales/interfaces';
import { GeneralApiService, StatusApi } from '@global-service/api';
import { ToastrService } from 'ngx-toastr';
import { SucursalService as OldSucursalService } from '@app/modules/sucursal/services/sucursal.service';
@Injectable()
export class SucursalService {

  constructor(private readonly generalApi: GeneralApiService, private readonly storageService: StorageService, private readonly toastr: ToastrService, private readonly oldSucursalService: OldSucursalService) {}

  get(sucursal_id: number, loading?: StatusApi) {
    return this.generalApi
      .callApi<Sucursal>('get', `/empresa/${this.storageService.getEmpresaID()}/sucursal/${sucursal_id}`, {
        loading,
      })
      .then((sucursal) => ({ ...sucursal, especificacionesAmbito: sucursal.especificacionesAmbito || {}, especificacionesGrupo: sucursal.especificacionesGrupo || {} }));
  }
  alta(sucursal: Sucursal, loading?: StatusApi) {
    return this.generalApi.callApi<{ sucursal_id: number }>('post', `/empresa/${this.storageService.getEmpresaID()}/sucursal/alta`, {
      postData: sucursal,
      loading,
      toastSuccess: `Sucursal creada correctamente`,
    });
  }
  async update(sucursal: Sucursal, loading?: StatusApi) {
    try {
      await this.generalApi.callApi<{ sucursal_id: number }>('post', `/empresa/${this.storageService.getEmpresaID()}/sucursal/actualizar`, {
        postData: sucursal,
        loading,
        toastError: null,
        toastSuccess: `Sucursal actualizada correctamente`,
      });
      return { esOk: true };
    } catch (error) {
      if (Array.isArray(error) && error.length > 0) {
        this.toastr.warning('Existen traspasos asociados a esta sucursal ');
        return { esOk: false, error: { traspasos: error } };
      }
      const message = error instanceof Error ? error.message : String(error);
      this.toastr.warning(message);
      return { esOk: false, error: null };
    }
  }
}
